import {VoteType} from './vote';

declare global {
  type UserComment = {
    id: number;
    uuid: string;
    content_type: CommentContentType;
    content_identifier: string;
    parent_uuid: string;
    created_at: string;
    create_time: string;
    uid: number;
    username: string;
    profile_img: string;
    body: string;
    body_text: string;
    top_comment: boolean;
    new_comment: boolean;
    is_deletable: boolean;
    upvotes: number;
    vote: VoteType;
    children: UserComment[];

    // Extra fields not always returned by the backend.
    question_title?: string;
    question_slug?: string;
    post_subject?: string;
    post_slug?: string;
    topic_name?: string;
    topic_slug?: string;
    reply_count?: number;
    trending_score?: number;
  };

  type CommentContentType = 'question' | 'post' | 'takehome';

  type CommentListConfig = {
    ordering: CommentListOrdering;
  };

  type CodeFormat = {
    code: string;
  };
}

export const enum CommentListOrdering {
  Trending = 'Trending',
  Rating = 'Rating',
  Recent = 'Recent',
}

export const DeletedCommentBody = 'Deleted';
